import IUserRepository from '../ports/outbound/IUserRepository';

export default class UserUseCase {
    constructor(private readonly repo: IUserRepository) { }

    async searchUsers( searchKey: string, signal?: AbortSignal) {
        return this.repo.searchUsers( searchKey, signal);
    }
}
